import { z } from 'zod';

import type {
  GetShipmentReportRequest,
  GetShipmentReportResponse,
} from './get-shipment-report.dto.js';
import {
  ShipmentReportDailyRowSchema,
  ShipmentReportTotalRowSchema,
} from './shipments-shared.schema.js';
import { ShipmentFormalReportDocumentSchema } from './formal-shipping-report-document.schema.js';

export const GetShipmentReportRequestSchema: z.ZodType<GetShipmentReportRequest> = z
  .object({
    companyId: z.uuid(),
    shipmentId: z.uuid(),
  })
  .strict();

export const GetShipmentReportResponseSchema: z.ZodType<GetShipmentReportResponse> = z
  .object({
    shipmentId: z.uuid(),
    hasDiscountAdjustedDays: z.boolean(),
    dailyRows: z.array(ShipmentReportDailyRowSchema),
    totalRow: ShipmentReportTotalRowSchema,
    formalDocument: ShipmentFormalReportDocumentSchema.optional(),
  })
  .strict();
